import React from "react";
import Banner from "./Banner";
import Trusted from "./Trusted";
import dynamic from "next/dynamic";
// import TechStack from "./TechStack";
const Faq = dynamic(() => import("./Faq"),{ssr: true});
const Serve = dynamic(() => import("./serve"),{ssr: true});
const Benefits = dynamic(() => import("./Benefits"),{ssr: true});
const Strategies = dynamic(() => import("./strategies"),{ssr: true});
const LatestNumber = dynamic(() => import("./LatestNumber"),{ssr: true});
const BuildSection = dynamic(() => import("@/Components/BuildSection"),{ssr: true});
const HocHead = dynamic(() => import("@/Components/HigherOrderComponent/HocHead"),{ssr: true});
const RFPForm = dynamic(() => import("@/Components/pages/TechnologyPage/technologies-new/Quote"),{ssr: true});
const Testimonials = dynamic(() => import("@/Components/pages/TechnologyPage/technologies-new/Review"),{ssr: true});
const CaseStudy = dynamic(() => import("@/Components/pages/TechnologyPage/technologies-new/Client-solution"),{ssr: true});
const TechnologiesStrategies = dynamic(() => import("@/Components/pages/TechnologyPage/technologies-new/Strategies"),{ssr: true});
const Process = dynamic(() => import("./process"),{ssr: true});

interface OtherServiceProps {
  slug: string;
  data?: any;
}

export interface TrustedByBlock {
  __component: "blocks.2025-home-trusted-by";
  id: number;
  title: string;
  slide: SlideItem[];
}

export interface SlideItem {
  id: number;
  tag: string;
  title: string;
  description: string;
  image: SlideImage;
  link: SlideLink;
  onButtonClick?: () => void | string;
  thumbDescription?: { url: string };
}

export interface SlideLink {
  id: number;
  href: string;
  label: string;
  target: string | null;
}

export interface SlideImage {
  id: number;
  name: string;
  url: string;
}

export interface FaqBlock {
  __component: "blocks.2025-home-rfp";
  id: number;
  title: string;
  faq: FaqItem[];
}

export interface FaqItem {
  id: number;
  question: string;
  answer: {
    type: string;
    children: {
      text: string;
      type: string;
    }[];
  }[];
}
export interface ServicesPartnerBlock {
  __component: "blocks.2025-partner";
  id: number;
  title: string;
  sub_title: string;
  partnerCards: {
    id: number;
    title: string;
    description: string;
    image: any;
  };
}

export interface TestimonialBlock {
  __component: "blocks.2025-testimonials";
  id: number;
  title: string;
  sub_title: string;
  testimonialCards: testimonialCards[];
}

export interface testimonialCards {
  id: number;
  title: string;
  rating: number;
  description: string;
  author: string;
  author_position: string;
  image: any;
}

const OtherService: React.FC<OtherServiceProps> = (props) => {
  const { data: sdata } = props;
  const data = sdata?.data?.[0]?.attributes;
  const seo = data?.seo;
  const blocks = data?.blocks;

  const renderBlock = (block: any, i: number) => {
    switch (block.__component) {
      case "blocks.home-new-banner":
        return <Banner key={i} block={block} />;
      case "blocks.2025-home-trusted-by":
        return <Trusted key={i} data={block} />;
      case "blocks.stats":
        return <LatestNumber key={i} data={block} />;
      // case "blocks.technical-prowess":
      //   return <TechStack key={i} data={block} />;
      case "blocks.strategies":
        return <Strategies key={i} data={block} />;
      case "blocks.tech-service-cta":
        return <BuildSection data={block} />;
      case "blocks.home-new-development-process":
        return <Process key={i} data={block} />;
      case "blocks.testimonials":
        return <Testimonials key={i} data={block} />;
      case "blocks.contact-us-case-study":
        return <CaseStudy key={i} data={block} viewCase={false} />;
      case "blocks.service-why-hire-us":
        return <TechnologiesStrategies key={i} data={block} />;
      case "blocks.home-new-form":
        return <RFPForm key={i} data={block} />;
      case "blocks.faq":
        return <Faq data={block} />;
      case "blocks.services-for-industries":
        return <Serve key={i} data={block} />;
      case "blocks.core-benefits":
        return <Benefits key={i} data={block} />;
      default:
        return null;
    }
  };

  return (
    <>
      {seo && <HocHead seo={seo} />}
      {blocks?.map((block: any, i: number) => renderBlock(block, i))}
    </>
  );
};

export default OtherService;
